module.exports = __webpack_public_path__ + "img/logo.a3737cb7.jpg";